import { render, staticRenderFns } from "./failed-orders.vue?vue&type=template&id=590b40ea&"
import script from "./failed-orders.vue?vue&type=script&lang=js&"
export * from "./failed-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports